"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardProfile = void 0;
var react_1 = __importDefault(require("react"));
var styled_1 = require("./styled");
var styled_2 = require("../styled");
// import { MetaSecondary } from "../../../generalUI/V2_MetaComps/MetaSecondary";
var MetaBlock_1 = __importDefault(require("../../MetaBlock"));
var styled_components_1 = require("styled-components");
var utilsOolib_1 = require("../../../utilsOolib");
var dontRenderIfBothOnClickAndTo_1 = require("../utils/dontRenderIfBothOnClickAndTo");
var decideLinkCompAndTarget_1 = require("../utils/decideLinkCompAndTarget");
var ProfileImageInput_1 = require("../../ImageInput/derivedComps/ProfileImageInput");
var injectHttps_1 = require("../../../utils/injectHttps");
var Typo_1 = require("../../Typo");
var Tags_1 = require("../../Tags");
var parseCardConfig_1 = require("../utils/parseCardConfig");
var LineClampWrapper_1 = require("../comps/LineClampWrapper");
var CardProfile = function (_a) {
    var id = _a.id, data = _a.data, config = _a.config, to = _a.to, onClick = _a.onClick, openInNewTab = _a.openInNewTab;
    var theme = (0, styled_components_1.useTheme)();
    var parseSpecialSyntax = (theme || {}).parseSpecialSyntax;
    var _b = (0, parseCardConfig_1.parseCardConfig)({ config: config, data: data, parseSpecialSyntax: parseSpecialSyntax }), cardLabel = _b.cardLabel, title = _b.title, image = _b.image, tagDisplay = _b.tagDisplay, metaBlock = _b.metaBlock;
    var dontRenderRes = (0, dontRenderIfBothOnClickAndTo_1.dontRenderIfBothOnClickAndTo)({ onClick: onClick, to: to });
    if (dontRenderRes)
        return dontRenderRes;
    var _c = (0, decideLinkCompAndTarget_1.decideLinkCompAndTarget)({
        to: to,
        openInNewTab: openInNewTab,
    }), LinkComp = _c.LinkComp, target = _c.target, externalUrl = _c.externalUrl;
    return (react_1.default.createElement(LinkComp, { target: target, href: (0, injectHttps_1.injectHttps)(to), to: to },
        react_1.default.createElement("div", { style: { position: 'relative' } },
            react_1.default.createElement(styled_1.StyledHoverBlocker, null),
            " ",
            react_1.default.createElement(styled_1.StyledCardUserProfile, { onClick: onClick, id: id },
                react_1.default.createElement(styled_1.StyledLinkWrapper, null,
                    react_1.default.createElement(styled_1.StyledImageWrapper, null,
                        react_1.default.createElement(ProfileImageInput_1.ProfileImageInput, { readOnly: true, id: "CardUserProfileImage", value: image, size: 120, imageTitle: title })),
                    react_1.default.createElement(styled_1.StyledCardDetails, { className: 'StyledCardDetails', style: !config.image ? { marginTop: 0 } : {} },
                        title && (react_1.default.createElement(LineClampWrapper_1.LineClampWrapper, { noOfLines_M: 3, title: title },
                            react_1.default.createElement(styled_1.StyledCardProfileTitle, { className: "StyledTitle" },
                                react_1.default.createElement(styled_2.StyledTitleSpan, { className: "StyledTitleSpan" }, title)))),
                        cardLabel && (react_1.default.createElement(LineClampWrapper_1.LineClampWrapper, { noOfLines_M: 2, title: title },
                            react_1.default.createElement(styled_1.StyledLabel, null,
                                react_1.default.createElement(Typo_1.LABEL, { color: (0, utilsOolib_1.getPrimaryColorText)(theme === null || theme === void 0 ? void 0 : theme.colors) }, cardLabel)))),
                        tagDisplay && (react_1.default.createElement(styled_1.StyledTag, null,
                            react_1.default.createElement(Tags_1.TagDisplay, { variant: "secondary", display: tagDisplay }))),
                        (metaBlock === null || metaBlock === void 0 ? void 0 : metaBlock.length) > 0 ? (react_1.default.createElement(styled_1.StyledMeta, null,
                            react_1.default.createElement(MetaBlock_1.default, { orientation: "vertical", data: data, config: metaBlock, align: "center" }))) : null))))));
};
exports.CardProfile = CardProfile;
